import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import { db } from "../../../firebase";

export async function getCampaigns(
  filterBy,
  lastSnapshot = "*",
  LimitCount = 10
) {
  try {
    const campaignsCollection = await collection(db, "campaign");
    console.log("filterBy: ", filterBy);

    let q =
      filterBy === "*"
        ? query(
            campaignsCollection,
            where("is_deleted", "==", false),
            where("bid", "==", getLocalStorageItem("bid")),
            orderBy("createdAt", "desc"),
            startAfter(lastSnapshot)
            // limit(LimitCount)
          )
        : query(
            campaignsCollection,
            where("is_deleted", "==", false),
            where("bid", "==", getLocalStorageItem("bid")),
            where("campaignSource", "==", filterBy),
            orderBy("createdAt", "desc")
            // limit(LimitCount)
          );
    const campaignSnapshot = await getDocs(q);
    console.log("campaignSnapshot: ", campaignSnapshot);
    let campaigns = [];
    campaignSnapshot.docs.forEach((doc) => {
      campaigns.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    return { campaigns, campaignSnapshot };
  } catch (ex) {
    console.log(ex);
    return [];
  }
}
